import ErrorBoundary from '../components/error/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const withErrorBoundary = WrappedComponent => {
  function WithErrorBoundary(props) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
    });
  }
  return WithErrorBoundary;
};
export default withErrorBoundary;